import React, {Fragment, useEffect, useState} from 'react';
//External
import {
    Button,
    ModalHeader, Modal, ModalBody
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPhone} from "@fortawesome/free-solid-svg-icons/faPhone";
import cx from "classnames";
import {Col, Row} from "react-bootstrap";
import requestApi from "../../../../services/requestApi.service";
import {CopyToClipboard} from "react-copy-to-clipboard";
import WebsiteWidget from "./WebsiteWidget";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import {getServerDomainURL, getSocketURL, parseJSON,handleErrorResponse} from "../../../../Common/Appcommon";
const ControllerComp = Controller;
const WebsiteChat = props => {
    const [defaultValue, setDefaultValues] = useState({});
    const [inputData, setInputData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [scriptTagContent, setScriptTagContent] = useState("")
    const [referenceHash, setReferenceHash] = useState("")
    const [isCopied, setTextCopied] = useState(false)
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    useEffect(() => {
        //if (userPrefersDark) document.body.classList.add("dark-theme");
        (async () => {
            await loadWebsiteChatData();
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);
    const loadWebsiteChatData = async (data) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_INTEGRATION",
            "NAME" : ctName
        }
        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            let data = res.data;
            if(data.length > 0){
                let dataStr = data[0][4];
                let refHash = data[0][1];
                setReferenceHash(refHash);

                if(dataStr !== "" && dataStr !== null){
                    let dataObj = parseJSON(dataStr);
                    if(Object.keys(dataObj).length > 0) {
                        setInputData(dataObj);
                        await getScriptTagContent();
                    }
                }
            }
        }
    }
    const websiteChatForm = useForm({
        defaultValues: defaultValue
    });
    let ctName = props.ctName;
    const { register, handleSubmit, control, formState: { errors } } = websiteChatForm;
    const submitForm = async (data) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "SAVE_INTEGRATION",
            "DATA" : inputData,
            "NAME" : ctName
        }
        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            let resdata = res.data;
            let refHash = resdata[0];
            setReferenceHash(refHash);
            setShowModal(true);
            await getScriptTagContent();
        }else{
            handleErrorResponse(res.errormsg);
        }
    }
    const getScriptTagContent = async () => {

        let widgetUrl = getSocketURL();
        let serverUrl = getServerDomainURL();
        serverUrl = serverUrl + "/whatsapp-widget.min.js?_="+ Math.random();
        let appUrl = window.location.protocol+"//"+window.location.hostname;
        let scriptTag = "<script>\n" +
            "(function (w, d, s, u) {\n" +
            "w.crwawc = {\n" +
            "url: \""+appUrl+"\",\n" +
            "options: {\n" +
            "        waId: \""+referenceHash+"\",\n" +
            "        widgetPosition: \"RIGHT\",\n" +
            "    },\n" +
            "};\n" +
            "var h = d.getElementsByTagName(s)[0],\n" +
            "j = d.createElement(s);\n" +
            "j.async = true;\n" +
            "j.src = \""+serverUrl+"\",\n" +
            "h.parentNode.insertBefore(j, h);\n" +
            "})(window, document, \"script\", \""+widgetUrl+"\");\n" +
            "</script>"
        setScriptTagContent(scriptTag)

    }
    const handleInputChange = (e) => {
        let tmpInputData = inputData;
        tmpInputData[e.target.name] = e.target.value;
        setInputData(tmpInputData);
        forceUpdate();
    }
    const toggleModalVisiblity = () => {
        setShowModal(!showModal);
    }
    return (
        <Fragment>
            <div className={'website-chat-container'}>
                <Modal className={'webiste-chat-modal'} size="lg" isOpen={showModal}  toggle={toggleModalVisiblity} >
                        <ModalHeader toggle={toggleModalVisiblity}>
                            {"Copy and paste this code before the </Body> tag on every page of your website."}
                        </ModalHeader>
                        <ModalBody>
                            <div className={'p-4'}>
                                <div className={'website-scripttag'}>
                                    <div>
                                        <CopyToClipboard onCopy={(e) => {setTextCopied(true)}} text={scriptTagContent}>
                                            <Button className={'copy-btn float-right'}>
                                                {isCopied ? "Copied!" : "Copy to Clipboard"}
                                            </Button>
                                        </CopyToClipboard>
                                        <br/>
                                    </div>
                                    <div className={'website-script-content'}>
                                        <pre id={"code"}>
                                            <pre className={"script-code"}>
                                                <code style={{ whiteSpace: "pre"}}>
                                                    {scriptTagContent}
                                                </code>

                                            </pre>
                                        </pre>
                                    </div>
                                    <div><p className="text-sm text-right py-3">Still you want edit the widget <a
                                        data-cy="click-here-link" className="cursor-pointer"
                                        onClick={(e) => {toggleModalVisiblity(e)}}>Click here</a></p></div>
                                </div>
                            </div>

                        </ModalBody>
                </Modal>
                <form name={'website_chat'} onSubmit={handleSubmit(submitForm)}>
                    <div className={'website-chat-form'}>
                        <div className={'cursor-pointer mb-3 goback-btn'} onClick={(e) => {props.onBackAction(e)}}>
                            <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                        </div>
                        <div className={'website-chat-header'}>
                            <div className={'d-flex-alone align-items-center'}>
                                <div className={'image-container'}>
                                    <FontAwesomeIcon className={`phone-icon`} icon={faPhone}/>
                                </div>
                                <div className={"header-text"}>
                                    Generate WhatsApp Live Chat Widget
                                </div>
                            </div>
                        </div>
                        <Row>
                            <Col md={"6"} className={'website-chat-content'}>
                                <Row className={'mb-3'}>

                                    <Col md="10" className={cx('pr-0 d-grid margin-left-3')}>
                                        <label className={'group-header-lbl'} htmlFor="wa_number">WhatsApp Number *</label>
                                        <ControllerComp
                                            name="wa_number"
                                            control={control}
                                            rules={{ required: inputData.wa_number !== undefined && inputData.wa_number !== "" ? false : "WhatsApp Number is required"}}
                                            render={({ field }) => {
                                                return (
                                                    <input
                                                        {...field}
                                                        type="number"
                                                        name="wa_number"
                                                        id="whatsapp-number"
                                                        value={inputData.wa_number !== undefined ? inputData.wa_number : ""}
                                                        autoComplete={"off"}
                                                        placeholder={"Enter your WhatsApp Number with country code"}
                                                        onChange={(e) => {
                                                            handleInputChange(e);
                                                            field.onChange(e);
                                                        }}
                                                        className={`form-control ${errors.wa_number ? 'is-invalid' : ''}`}
                                                    />
                                                );
                                            }}
                                        />
                                        <p className="text-sm text-gray-400">Example: 919998887776</p>
                                        {errors.wa_number && <em className={`error invalid-feedback`}>{errors.wa_number.message}</em>}
                                    </Col>
                                </Row>
                                <Row className={'mb-3'}>

                                    <Col md="10" className={cx('pr-0 d-grid margin-left-3')}>
                                        <label className={'group-header-lbl'} htmlFor="brandName">Name of your business/brand *</label>
                                        <ControllerComp
                                            name="brandName"
                                            control={control}
                                            rules={{ required: inputData.brandName !== undefined && inputData.brandName !== "" ? false : "Name is required"}}
                                            render={({ field }) => {
                                                return (
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        name="brandName"
                                                        id="brand-name"
                                                        value={inputData.brandName !== undefined ? inputData.brandName : ""}
                                                        autoComplete={"off"}
                                                        placeholder={"Name to be displayed in widget"}
                                                        onChange={(e) => {
                                                            handleInputChange(e);
                                                            field.onChange(e);
                                                        }}
                                                        className={`form-control ${errors.brandName ? 'is-invalid' : ''}`}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.brandName && <em className={`error invalid-feedback`}>{errors.brandName.message}</em>}
                                    </Col>
                                </Row>
                                <Row className={'mb-3'}>

                                    <Col md="10" className={cx('pr-0 d-grid margin-left-3')}>
                                        <label className={'group-header-lbl'} htmlFor="availableTag">Availability tag *</label>
                                        <ControllerComp
                                            name="availableTag"
                                            control={control}
                                            rules={{ required: inputData.availableTag !== undefined && inputData.availableTag !== "" ? false : "Status tag is required"}}
                                            render={({ field }) => {
                                                return (
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        name="availableTag"
                                                        id="status-tag"
                                                        value={inputData.availableTag !== undefined ? inputData.availableTag : ""}
                                                        autoComplete={"off"}
                                                        placeholder={"Your availability information"}
                                                        onChange={(e) => {
                                                            handleInputChange(e);
                                                            field.onChange(e);
                                                        }}
                                                        className={`form-control ${errors.availableTag ? 'is-invalid' : ''}`}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.availableTag && <em className={`error invalid-feedback`}>{errors.availableTag.message}</em>}
                                    </Col>
                                </Row>
                                <Row className={'mb-3'}>

                                    <Col md="10" className={cx('pr-0 d-grid margin-left-3')}>
                                        <label className={'group-header-lbl'} htmlFor="logoUrl">Your Logo</label>
                                        <ControllerComp
                                            name="logoUrl"
                                            control={control}
                                            rules={{ required: false}}
                                            render={({ field }) => {
                                                return (
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        name="logoUrl"
                                                        id="logo-url"
                                                        value={inputData.logoUrl !== undefined ? inputData.logoUrl : ""}
                                                        autoComplete={"off"}
                                                        placeholder={"Logo URL"}
                                                        onChange={(e) => {
                                                            handleInputChange(e);
                                                            field.onChange(e);
                                                        }}
                                                        className={`form-control `}
                                                    />
                                                );
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className={'mb-3'}>

                                    <Col md="10" className={cx('pr-0 d-grid margin-left-3')}>
                                        <label className={'group-header-lbl'} htmlFor="welcomeTxt">Welcome Text *</label>
                                        <ControllerComp
                                            name="welcomeTxt"
                                            control={control}
                                            rules={{ required: inputData.welcomeTxt !== undefined && inputData.welcomeTxt !== "" ? false : "Welcome Text is required"}}
                                            render={({ field }) => {
                                                return (
                                                    <textarea
                                                        {...field}
                                                        name="welcomeTxt"
                                                        id="welcome-text"
                                                        value={inputData.welcomeTxt !== undefined ? inputData.welcomeTxt : ""}
                                                        autoComplete={"off"}
                                                        placeholder={"Hi, there! 👋\n" +
                                                        "How can I help you?\n"}
                                                        onChange={(e) => {
                                                            handleInputChange(e);
                                                            field.onChange(e);
                                                        }}
                                                        className={`form-control ${errors.welcomeTxt ? 'is-invalid' : ''}`}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.welcomeTxt && <em className={`error invalid-feedback`}>{errors.welcomeTxt.message}</em>}
                                    </Col>
                                </Row>
                                <Row className={'mb-3'}>

                                    <Col md="10" className={cx('pr-0 d-grid margin-left-3')}>
                                        <label className={'group-header-lbl'} htmlFor="triggerMsg">Trigger Message *</label>
                                        <ControllerComp
                                            name="triggerMsg"
                                            control={control}
                                            rules={{ required: inputData.triggerMsg !== undefined && inputData.triggerMsg !== "" ? false : "Trigger message is required"}}
                                            render={({ field }) => {
                                                return (
                                                    <textarea
                                                        {...field}
                                                        name="triggerMsg"
                                                        id="trigger-text"
                                                        value={inputData.triggerMsg !== undefined ? inputData.triggerMsg : ""}
                                                        autoComplete={"off"}
                                                        placeholder={"Add custom message that user will send to you"}
                                                        onChange={(e) => {
                                                            handleInputChange(e);
                                                            field.onChange(e);
                                                        }}
                                                        className={`form-control ${errors.triggerMsg ? 'is-invalid' : ''}`}
                                                    />
                                                );
                                            }}
                                        />
                                        <p className="text-sm text-gray-400">Example: “Hello, I am interested to know more about your business”.</p>
                                        {errors.triggerMsg && <em className={`error invalid-feedback`}>{errors.triggerMsg.message}</em>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="10" className={cx('pr-0 d-grid margin-left-3')}>
                                        <Button color={'success'} >
                                            Generate Widget Code
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={"6"} className={'content-preview'}>
                                {Object.keys(inputData).length > 0 && <WebsiteWidget isPreviewWidget={true} widgetData={inputData} /> }
                            </Col>
                        </Row>
                    </div>
                </form>
            </div>
        </Fragment>
    )
}

export default WebsiteChat
